import { render, staticRenderFns } from "./plan_buyers_products.vue?vue&type=template&id=3ba7a740&scoped=true"
import script from "./plan_buyers_products.vue?vue&type=script&lang=js"
export * from "./plan_buyers_products.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba7a740",
  null
  
)

export default component.exports